module.exports = __webpack_public_path__ + "static/media/010.7f28aea1.jpg";